import React, {FC} from 'react';

import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {emojiToDefinition} from '../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {SheetEmoji} from '../../components/common/emoji/sheetEmoji';
import {HighlightTypesEnum} from '../../models/api/highlightBaseModel';
import {TagModel} from '../../models/api/tagModel';
import {baseEmojiValidationMap} from '../../services/emojis/emojis';

/*
 * Props.
 */

interface SettingsTagsBreadcrumbItemProps {
  tag: TagModel;
}

/*
 * Component.
 */

export const SettingsTagsBreadcrumbItem: FC<SettingsTagsBreadcrumbItemProps> = (props) => {
  const theme = useUserTheme();
  const {tag} = props;

  if (tag.type === HighlightTypesEnum.EMOJI) {
    const definition = emojiToDefinition(tag.highlightEmoji, baseEmojiValidationMap);

    if (definition) {
      return (
        <>
          <SheetEmoji {...definition} size={14} />
          {tag.name}
        </>
      );
    }
  }

  const iconColor =
    tag.type === HighlightTypesEnum.COLOR ? theme.palette[tag.highlightColor].shade40 : theme.greys.shade70;

  return (
    <>
      <Icon color={iconColor} name="tagFilledSmall" />
      {tag.name}
    </>
  );
};
